import { render, staticRenderFns } from "./thirdparty.vue?vue&type=template&id=15945ff3&"
import script from "./thirdparty.vue?vue&type=script&lang=js&"
export * from "./thirdparty.vue?vue&type=script&lang=js&"
import style0 from "./thirdparty.vue?vue&type=style&index=0&id=15945ff3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports